import i18n from '@/i18n'

const getAxisWithValue = (xValue, yValue) => {
    const x = `${i18n.t('nBox.xAxis')}: ${xValue != null ? xValue : '-'}`
    const y = `${i18n.t('nBox.yAxis')}: ${yValue != null ? yValue : '-'}`
    return x + ' | ' + y
}

const getQuadrantTitle = quadrant => {
    if (quadrant.title === null) {
        const { x_axis, y_axis } = quadrant
        return getAxisWithValue(x_axis, y_axis)
    }

    return quadrant.title
}

const getCentralValue = (min, max) => max - (max - min) / 2

export { getQuadrantTitle, getAxisWithValue, getCentralValue }
